import { usePontosOperacionaisStore } from '../../stores/usePontosOperacionaisStore';

export function usePontosOperacionais() {

    return usePontosOperacionaisStore(
        state => state.pontosOperacionais
    );
}